module.exports = __webpack_public_path__ + "img/sharp3.b1214185.png";